import '../sass/image-and-text.scss';

(() => {
    const $imageAndTextBlocks = document.querySelectorAll('.image-and-text-block');

    if (!$imageAndTextBlocks) return;

    $imageAndTextBlocks.forEach(($imageAndTextBlock) => {
        const $imageCarousel = $imageAndTextBlock.querySelector('.image-and-text-block__carousel');

        const initCarousel = () => {
            if (!$imageCarousel) return;

            new Swiper($imageCarousel, {
                loop: true,
                effect: 'fade',
                autoplay: true,
                disableOnInteraction: false,
                allowTouchMove: false,
            });
        };

        initCarousel();
    });
})();
